import { Spinner } from "react-bootstrap";

const ReviewsTab = ({ reviewData, isReviewLoading, t }) => {
  if (isReviewLoading)
    return (
      <p className="justify-content-center text-center">
        <Spinner />
      </p>
    );

  if (!reviewData?.data?.length) {
    return (
      <p className="justify-content-center text-center text-muted">
        {t("noReviewFound")}
      </p>
    );
  }

  return (
    <div className="row justify-content-center">
      <div className="col-lg-8">
        {reviewData.data.map((review) => {
          const fullName =
            `${review.user?.first_name || ""} ${review.user?.last_name || ""}`.trim();
          const initials = `${review.user?.first_name?.[0] || ""}${review.user?.last_name?.[0] || ""}`;

          return (
            <div
              key={review._id}
              className="d-flex gap-3 p-3 mb-3 rounded shadow-sm profile-review-card"
              style={{
                backgroundColor: "#0e0e18",
                border: "0px solid rgba(255,255,255,0.05)",
              }}
            >
              {/* Avatar */}
              {review.user?.picture ? (
                <img
                  src={review.user.picture}
                  alt={fullName}
                  className="rounded-circle"
                  style={{
                    width: 45,
                    height: 45,
                    objectFit: "cover",
                    flexShrink: 0,
                  }}
                />
              ) : (
                <div
                  className="d-flex align-items-center justify-content-center rounded-circle fw-bold"
                  style={{
                    width: 45,
                    height: 45,
                    backgroundColor: "#2a2a40",
                    color: "#fff",
                    flexShrink: 0,
                  }}
                >
                  {initials || "U"}
                </div>
              )}

              {/* Content */}
              <div className="w-100">
                {/* Top Row */}
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6
                      className="mb-0 fw-semibold"
                      style={{ color: "#ffffff" }}
                    >
                      {fullName || "Unknown User"}
                    </h6>

                    <small style={{ color: "#9ca3af" }}>
                      {review.course?.title || "Unknown Course"}
                    </small>
                  </div>

                  {/* Rating */}
                  <div style={{ color: "#facc15", fontSize: "20px" }}>
                    {[1, 2, 3, 4, 5].map((i) => (
                      <span key={i}>{i <= review.rating ? "★" : "☆"}</span>
                    ))}
                  </div>
                </div>

                {/* Message */}
                <p className="mt-2 mb-1" style={{ color: "#e5e7eb" }}>
                  {review?.message}
                </p>

                {/* Date */}
                <small style={{ color: "#6b7280" }}>
                  {(() => {
                    const d = new Date(review?.createdAt);
                    const day = String(d.getDate()).padStart(2, "0");
                    const month = String(d.getMonth() + 1).padStart(2, "0");
                    const year = d.getFullYear();
                    return `${day}-${month}-${year}`;
                  })()}
                </small>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ReviewsTab;
